window.addEventListener('DOMContentLoaded', () => {

    $(function(){
      $('.newsletter .newsletter__form-wrapper form').submit(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        var form = $(this);
        var error = false;
  
        form.find('.error-msg').hide();
        form.find('.error').removeClass('error');
  
        form.find('.required').each(function(){
          if($(this).val()=="") {
            error = true;
            $(this).addClass('error');
          }
        });
        if(error){
            form.find('.error-msg').show().text('Please complete all the required fields.');
        }else{
          if(!Simplistic.validateEmail(form.find('.email').val())) {
            error = true;
            form.find('.email').addClass('error');
            form.find('.error-msg').show().text('Please provide a valid email address.');
          }
        }
        if(!error) {
          $.ajax({
            data: form.serialize(),
            url: form.data('ajax-submit'),
            type: 'POST'
          }).done(function(data){
            if (typeof(data)=='string' && data.indexOf('property="og:title" '+'content="Challenge"')>-1) {
              form.unbind("submit");
              form.submit();
            } else {
              form.find('.form-wrap').hide();
              form.find('.success-msg').show();
            }
          }).error(function(){
            form.unbind("submit");
            form.submit();
          });
        }
      });

      // blog article info match height functionality
      const elsToMatch = $('.article-content-right ul:first-of-type, .article-title')
      if (elsToMatch) {
        Simplistic.matchHeight($('.article-content-right ul:first-of-type, .article-title'))
      }

    });
})